import { CAMERA_FACING, LAYOUT, SESSION_TYPE } from '@cometchat/calls-sdk-core';

export const CALL_CONSTANTS = {
  LAYOUT: LAYOUT,
  TYPE: SESSION_TYPE,
  CAMERA_FACING: CAMERA_FACING,
};
